import * as common from '../apiCommon';
import * as DocType from '../../constants/constant_doc_types';


export function deleteHotkeyTemplate(app, params) {
  const { id } = params;
  return common.deleteDoc(app, {
    id: id,
    docType: DocType.HOTKEY_TEMPLATE
  });
}


export function fetchHotkeyTemplateForEdit(app, params) {
  const { id } = params;
  const docType = DocType.HOTKEY_TEMPLATE;
  return common.getDoc(app, { id, docType });
}


export function fetchHotkeyTemplateDropdown(app, params) {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = 'hotkey_template/dropdown';
  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams
  };

  return common.getDropdownList(app, { query });
}
